(function () {
  if (window.__agAddonLoaded) return;
  window.__agAddonLoaded = true;

  var SLIDES = [
    { t: 'Full metal build', d: 'Solid metal links that match your watch. Built to take a hit on the job, not to sit on a shelf.' },
    { t: 'Made for your watch', d: 'Quick-release pins, exact fit. No adapters, no guessing.' },
    { t: 'Swap in seconds', d: 'Pop the pins, snap the band. No tools required. Keep your original band as a spare.' }
  ];
  var DYNAMIC = '.shopify-payment-button, [data-shopify="payment-button"]';
  var KACHING = 'kaching-bundle, [name^="properties[__kaching"]';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function box() { return document.getElementById('ag-addon'); }
  function input() { return document.getElementById('ag-addon-input'); }
  function modal() { return document.getElementById('ag-addon-modal'); }

  // ---------- El formulario pertenece al producto del toggle? (principal o sticky) ----------
  function isOurForm(form) {
    var b = box();
    if (!b || !form || form.tagName !== 'FORM') return false;
    var pid = form.querySelector('input[name="product-id"]');
    if (pid) return pid.value === b.dataset.productId;
    return (form.getAttribute('id') || '').indexOf(b.dataset.productId) !== -1;
  }

  // El formulario de compra real (no el de cuotas de Shop Pay, no los del cart drawer)
  function ourForm() {
    var list = document.querySelectorAll('form[is="product-form"], form[action*="/cart/add"]');
    for (var k = 0; k < list.length; k++) {
      var f = list[k];
      // ojo: f.id devuelve el input name="id"; el id del form se lee con getAttribute
      if (/installment/i.test(f.getAttribute('id') || '')) continue;
      if (f.closest && f.closest('#shopify-section-mini-cart, cart-drawer, .drawer')) continue;
      if (isOurForm(f)) return f;
    }
    return null;
  }

  // ---------- Color seleccionado (Focal) ----------
  // Devuelve null si el reloj no tiene selector de color
  function selectedColor() {
    var b = box();
    if (b && b.dataset.hasMap === 'true') return b.dataset.hasColor === 'true' ? (b.dataset.mapColor || 'gunmetal') : null;
    if (b && b.dataset.hasColor !== 'true') return null;
    var sel = $('.product-form__option-selector[data-selector-type="color"] input:checked')
           || $('input[name="option1"]:checked');
    if (sel && sel.value) return String(sel.value).toLowerCase();
    return null;
  }

  function setDynamicHidden(hidden) {
    document.querySelectorAll(DYNAMIC).forEach(function (el) { el.style.display = hidden ? 'none' : ''; });
  }

  // ---------- Estado de la banda activa ----------
  var state = { color: 'gunmetal', hasColor: true, choice: null, slide: 0, variantId: null, lastVid: null };
  var MAP = null;
  function loadMap() {
    if (MAP && Object.keys(MAP).length) return MAP;
    var el = document.querySelector('script[data-ag-map]');
    try { MAP = el ? JSON.parse(el.textContent) : {}; } catch (e) { MAP = {}; }
    return MAP;
  }
  // Kaching (BOGO): el cliente elige el reloj en el selector de Kaching, que NO avisa al tema.
  // Se lee el primer grupo de selects de la barra elegida (el producto principal) y se busca por titulo.
  function kachingRoot() {
    var b = box(); if (!b) return null;
    var f = ourForm();
    return (f && f.querySelector('kaching-bundle')) || document.querySelector('kaching-bundle[product-id="' + b.dataset.productId + '"]');
  }
  function kachingVariantId() {
    var b = box(); if (!b || b.dataset.hasMap !== 'true') return null;
    var root = kachingRoot(); if (!root) return null;
    var bar = root.querySelector('.kaching-bundles__bar--selected') || root;
    var group = bar.querySelector('.kaching-bundles__bar-variant-selects') || bar;
    var sels = group.querySelectorAll('select');
    if (!sels.length) return null;
    var title = Array.prototype.map.call(sels, function (s) { return String(s.value || s.getAttribute('data-value') || '').trim(); }).join(' / ').toLowerCase();
    var m = loadMap();
    for (var k in m) { if (m.hasOwnProperty(k) && String(m[k].title || '').trim().toLowerCase() === title) return k; }
    return null;
  }
  function currentVariantId() {
    var kv = kachingVariantId(); if (kv) return kv;
    if (state.variantId) return String(state.variantId);
    var f = ourForm();
    var inp = f ? f.querySelector('[name="id"]') : null;
    return inp && inp.value ? String(inp.value) : null;
  }
  // Promos: si la variante elegida apunta a un reloj, copia sus bandas al dataset del bloque
  function applyMap() {
    var b = box(); if (!b || b.dataset.hasMap !== 'true') return;
    var vid = currentVariantId(); var m = loadMap(); var e = vid ? m[vid] : null;
    if (!e) e = { watch: '', color: '', g: null, s: null };
    ['g', 's'].forEach(function (k) {
      var d = e[k];
      var set = function (f, v) { b.dataset[k + f] = v || ''; };
      if (d) { set('Id', d.id); set('Label', d.label); set('Price', d.price); set('Compare', d.compare); set('Thumb', d.thumb); set('Img1', d.img1); set('Img2', d.img2); set('Img3', d.img3); }
      else { set('Id', ''); set('Label', ''); set('Price', ''); set('Compare', ''); set('Thumb', ''); set('Img1', ''); set('Img2', ''); set('Img3', ''); }
    });
    b.dataset.hasColor = e.color ? 'true' : 'false';
    b.dataset.mapColor = e.color || '';
    if (e.watch) document.querySelectorAll('[data-ag-watch]').forEach(function (n) { n.textContent = e.watch; });
    var pick = $('[data-ag-pick]', b); if (pick) { if (b.dataset.gId && b.dataset.sId) pick.removeAttribute('hidden'); else pick.setAttribute('hidden', ''); }
    b.querySelectorAll('[data-ag-pill]').forEach(function (p) {
      var k = p.dataset.agPill, lab = b.dataset[k + 'Label'];
      var txt = p.childNodes[p.childNodes.length - 1]; if (txt && txt.nodeType === 3 && lab) txt.nodeValue = lab;
    });
  }

  // Regla: banda del color CONTRARIO al reloj. Si no existe, la que haya (Raptor Pro).
  function bandData() {
    var b = box();
    if (!b) return null;
    var d = b.dataset;
    var want;
    if (state.choice) want = state.choice;                 // el cliente eligio una pill
    else if (!state.hasColor) want = 'g';                  // reloj sin opcion Color: Black por defecto
    else want = state.color === 'silver' ? 'g' : 's';      // contraria al color del reloj
    var other = want === 'g' ? 's' : 'g';
    var k = d[want + 'Id'] ? want : (d[other + 'Id'] ? other : want);
    state.key = k;
    return {
      id: d[k + 'Id'], price: d[k + 'Price'], compare: d[k + 'Compare'],
      imgs: [d[k + 'Img1'], d[k + 'Img2'], d[k + 'Img3']].filter(Boolean),
      thumb: d[k + 'Thumb'] || '',
      label: d[k + 'Label'] || (k === 'g' ? 'Black' : 'Silver')
    };
  }

  // Solo si cambio el reloj se olvida la pill elegida (abrir el modal de Kaching no la borra)
  function syncVariant() {
    var vid = currentVariantId();
    if (vid !== state.lastVid) { state.choice = null; state.lastVid = vid; }
    refresh();
  }

  function refresh() {
    var b = box(), i = input();
    if (!b || !i) return;
    applyMap();

    var c = selectedColor();
    state.hasColor = c !== null;
    state.color = (c || '').indexOf('silver') !== -1 ? 'silver' : 'gunmetal';
    var d = bandData();

    // Sin banda para esta variante: esconder todo
    if (!d.id) {
      b.style.display = 'none';
      i.checked = false;
      var card0 = document.getElementById('ag-addon-card'); if (card0) card0.classList.remove('is-on');
      setDynamicHidden(false);
      return;
    }
    b.style.display = '';
    i.dataset.bandVariant = d.id;
    $('[data-ag-color]', b).textContent = d.label;
    $('[data-ag-price]', b).textContent = d.price;
    $('[data-ag-compare]', b).textContent = d.compare || '';
    var sv = $('[data-ag-save]', b);
    if (sv) {
      var cn = parseFloat((d.compare || '').replace(/[^0-9.]/g, ''));
      var pn = parseFloat((d.price || '').replace(/[^0-9.]/g, ''));
      sv.textContent = (cn > pn) ? 'YOU SAVE $' + (Math.round((cn - pn) * 100) / 100).toFixed(2).replace(/\.00$/, '') : '';
    }
    var im = $('[data-ag-img]', b); if (im) { var tsrc = d.thumb || (d.imgs[0] ? d.imgs[0].replace('width=600', 'width=120') : ''); if (tsrc) im.src = tsrc; }
    b.querySelectorAll('[data-ag-pill]').forEach(function (p) { p.classList.toggle('is-on', p.dataset.agPill === state.key); });
    renderModal();
  }

  // ---------- Modal ----------
  function renderModal() {
    var m = modal(), d = bandData(), i = input();
    if (!m || !d) return;
    var s = SLIDES[state.slide];
    $('[data-ag-modal-color]', m).textContent = d.label;
    var mi = $('[data-ag-modal-img]', m); var msrc = d.imgs[state.slide] || d.imgs[0] || ''; if (msrc) mi.src = msrc;
    $('[data-ag-slide-title]', m).textContent = s.t;
    $('[data-ag-slide-desc]', m).textContent = s.d;
    $('[data-ag-dots]', m).innerHTML = SLIDES.map(function (_, k) { return '<i class="' + (k === state.slide ? 'on' : '') + '"></i>'; }).join('');
    var btn = $('[data-ag-select]', m);
    btn.textContent = i && i.checked ? 'Selected ✓' : 'Select this add-on';
    btn.classList.toggle('is-selected', !!(i && i.checked));
  }
  function openModal() { var m = modal(); if (!m) return; state.slide = 0; renderModal(); m.hidden = false; m.style.display = 'flex'; m.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeModal() { var m = modal(); if (!m) return; m.classList.remove('is-open'); m.style.display = 'none'; m.hidden = true; document.body.style.overflow = ''; }

  // ---------- Carrito ----------
  function postItems(items, withSections) {
    var payload = { items: items };
    if (withSections) payload.sections = 'mini-cart';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  // ---------- Medidor (solo con ?agdebug=1 en la URL) ----------
  var DEBUG = /[?&]agdebug=1/.test(location.search);
  var T = { click: 0, add: 0, band: false, shown: true };
  function mark(k) {
    if (!DEBUG || !window.performance) return;
    if (k === 'click') { T = { click: performance.now(), add: 0, band: false, shown: false }; return; }
    if (k === 'add') { T.add = performance.now(); return; }
    if (k === 'drawer' && T.click && !T.shown) {
      T.shown = true;
      var addMs = T.add ? Math.round(T.add - T.click) : '?';
      var totalMs = Math.round(performance.now() - T.click);
      var el = document.getElementById('ag-debug');
      if (!el) {
        el = document.createElement('div'); el.id = 'ag-debug';
        el.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:2147483647;background:#000;color:#FFD300;font:600 12px/1.45 monospace;padding:8px 10px;border-radius:6px;max-width:92vw;pointer-events:none;white-space:pre';
        document.body.appendChild(el);
      }
      var line = 'Band ' + (T.band ? 'ON ' : 'OFF') + ' | Add to cart: ' + addMs + ' ms | Drawer open: ' + totalMs + ' ms';
      el.textContent = (line + '\n' + el.textContent).split('\n').slice(0, 5).join('\n');
    }
  }
  document.documentElement.addEventListener('cart:refresh', function (e) { if (e.detail && e.detail.openMiniCart) mark('drawer'); });

  // ---------- Drawer rapido ----------
  // La respuesta del Add to Cart ya trae el drawer armado (sections). Se abre con eso al instante,
  // sin esperar la segunda lectura del carrito. El refresco del tema que llega despues trae
  // exactamente el mismo HTML, asi que se omite para que el drawer no se recargue.
  var fast = null; // { html, until }
  function cartCountNow() {
    var el = document.querySelector('cart-count');
    var n = el ? parseInt(el.textContent, 10) : NaN;
    return isNaN(n) ? 0 : n;
  }
  function openFromAddResponse(json, themeWillRefresh) {
    try {
      var html = json && json.sections && json.sections['mini-cart'];
      if (!html) return false;
      var items = json.items || (json.id ? [json] : []);
      var added = items.reduce(function (s, it) { return s + (Number(it.quantity) || 0); }, 0);
      // item_count aproximado: el cart:updated del tema lo corrige un instante despues
      var cart = { item_count: Math.max(1, cartCountNow() + added), items: items, sections: json.sections };
      var tv = window.themeVariables && window.themeVariables.settings;
      var openMini = !tv || tv.cartType === 'drawer';
      // Solo cuando el tema va a mandar su propio refresco despues (promos); en la PDP con banda no hay
      fast = themeWillRefresh ? { html: html, until: Date.now() + 6000 } : null;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: openMini, agBand: true, agFast: true } }));
      return true;
    } catch (err) { fast = null; return false; }
  }
  window.addEventListener('cart:refresh', function (e) {
    if (!fast) return;
    var d = e.detail || {};
    if (d.agFast) return;
    if (Date.now() > fast.until) { fast = null; return; }
    var html = d.cart && d.cart.sections && d.cart.sections['mini-cart'];
    if (html && html === fast.html) { e.stopImmediatePropagation(); fast = null; }
  }, true);
  function fastOpen(res) {
    mark('add');
    try { res.clone().json().then(function (json) { openFromAddResponse(json, true); }).catch(function () {}); } catch (err) {}
  }
  // Cuenta real del carrito (para el numerito del header y las apps), sin bloquear el drawer
  function broadcastCart() {
    var url = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
    fetch(url + '.js', { cache: 'reload' }).then(function (r) { return r.json(); }).then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, agBand: true } }));
    }).catch(function () {});
  }
  // Abre / refresca el cart drawer de Focal con los mismos eventos que usa el tema
  async function openCartDrawer() {
    try {
      var url = (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
      var cart = await (await fetch(url + '.js', { cache: 'reload' })).json();
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart, agBand: true } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true, agBand: true } }));
      return true;
    } catch (err) { return false; }
  }

  function notice(msg) {
    var n = $('[data-ag-notice]', box());
    if (!n) return;
    n.textContent = msg; n.hidden = false;
  }

  // ---------- Promos / Kaching: banda en el MISMO pedido del Add to Cart (v6.3) ----------
  // No se toca el boton ni el formulario. El tema arma su pedido normal y, justo antes de salir,
  // se le suma la banda como segundo producto (formato items[]). Kaching lee ese formato, agrega
  // el reloj FREE y conserva la banda. Resultado: un solo viaje al servidor, el drawer abre una vez.
  // Si el pedido con banda es rechazado (banda agotada), se manda el pedido original sin banda.
  var armed = null; // { id, at, used, fallback }
  function afterMode(form) {
    var b = box();
    if (b && b.dataset.hasMap === 'true') return true;
    return !!(form && form.querySelector(KACHING));
  }
  function cartUrl() {
    return (window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartUrl) || '/cart';
  }
  function bandItem(bandId) { return { id: Number(bandId), quantity: 1, properties: { '_added_with_watch': 'true' } }; }
  // FormData de un producto (id, quantity, properties[x]) -> items[0] + items[1] (banda)
  function withBandFormData(fd, bandId) {
    if (!fd.get('id')) return null;
    var hasItems = false; fd.forEach(function (v, k) { if (/^items\[/.test(k)) hasItems = true; });
    if (hasItems) return null;
    var out = new FormData();
    out.append('items[0][id]', String(fd.get('id')));
    out.append('items[0][quantity]', String(fd.get('quantity') || 1));
    fd.forEach(function (v, k) {
      var m = k.match(/^properties\[(.+)\]$/);
      if (m) { out.append('items[0][properties][' + m[1] + ']', v); return; }
      if (k === 'selling_plan' || k === 'parent_id') { out.append('items[0][' + k + ']', v); return; }
      if (k === 'id' || k === 'quantity') return;
      out.append(k, v);
    });
    out.append('items[1][id]', String(bandId));
    out.append('items[1][quantity]', '1');
    out.append('items[1][properties][_added_with_watch]', 'true');
    return out;
  }
  // JSON de un producto ({id, quantity, properties}) -> {items:[producto, banda]}
  function withBandJson(str, bandId) {
    var o; try { o = JSON.parse(str); } catch (e) { return null; }
    if (!o || !o.id || o.items) return null;
    var main = { id: Number(o.id), quantity: Number(o.quantity) || 1, properties: o.properties || {} };
    if (o.selling_plan) main.selling_plan = o.selling_plan;
    var rest = {}; Object.keys(o).forEach(function (k) { if (['id', 'quantity', 'properties', 'selling_plan'].indexOf(k) === -1) rest[k] = o[k]; });
    rest.items = [main, bandItem(bandId)];
    return JSON.stringify(rest);
  }
  function isCartAdd(url) {
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    return /\/cart\/add(\.js)?(\?|$)/.test(u);
  }
  function armFetch(bandId) {
    if (!window.fetch) return null;
    var next = window.fetch;
    var st = { id: bandId, at: Date.now(), used: false, bandRode: false, fallback: false };
    function restore() { if (window.fetch === wrapper) window.fetch = next; }
    function wrapper(url, opts) {
      if (!st.used && isCartAdd(url) && opts && opts.body) {
        st.used = true; restore();
        var self = this;
        var body2 = null;
        if (bandId) {
          if (typeof FormData !== 'undefined' && opts.body instanceof FormData) body2 = withBandFormData(opts.body, bandId);
          else if (typeof opts.body === 'string') body2 = withBandJson(opts.body, bandId);
        }
        st.bandRode = !!body2;
        var send = function (o) { return next.call(self, url, o); };
        var o2 = opts;
        if (body2) { o2 = {}; Object.keys(opts).forEach(function (k) { o2[k] = opts[k]; }); o2.body = body2; }
        var retry = function () {
          return send(opts).then(function (r2) {
            if (r2.ok) {
              notice('The metal band just sold out. Your watch was added to the cart.');
              document.dispatchEvent(new CustomEvent('ag:band-added', { detail: { items: [], bandFailed: true, mode: 'same-request' } }));
              fastOpen(r2);
            }
            return r2;
          });
        };
        return send(o2).then(function (res) {
          if (res.ok) {
            if (body2) document.dispatchEvent(new CustomEvent('ag:band-added', { detail: { items: [bandItem(bandId)], mode: 'same-request' } }));
            fastOpen(res);
            return res;
          }
          return body2 ? retry() : res;
        }, function (err) {
          if (body2) return retry();
          throw err;
        });
      }
      return next.apply(this, arguments);
    }
    window.fetch = wrapper;
    setTimeout(function () { st.used = true; restore(); }, 10000);
    return st;
  }
  // Red de seguridad: si el tema no mando su pedido por fetch (no paso por la banda),
  // la banda entra justo despues y el drawer se actualiza (comportamiento de la v6.1).
  async function addBandLate(bandId) {
    try {
      var cart = await (await fetch(cartUrl() + '.js', { cache: 'reload' })).json();
      if (!hasOurProduct(cart)) return;
      var res = await postItems([bandItem(bandId)]);
      if (!res.ok) { notice('The metal band just sold out. Your watch was added to the cart.'); return; }
      document.dispatchEvent(new CustomEvent('ag:band-added', { detail: { items: [bandItem(bandId)], mode: 'late' } }));
      await openCartDrawer();
    } catch (e) {}
  }
  function hasOurProduct(cart) {
    var b = box(); var pid = b ? Number(b.dataset.productId) : 0;
    return !!(cart && (cart.items || []).some(function (it) { return Number(it.product_id) === pid; }));
  }
  document.addEventListener('variant:added', function (e) {
    if (!armed || !armed.id || armed.bandRode || armed.fallback) return;
    if (e.target && e.target.tagName === 'FORM' && !isOurForm(e.target)) return;
    if (Date.now() - armed.at > 10000) return;
    armed.fallback = true;
    addBandLate(armed.id);
  });

  // ---------- Eventos ----------
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.id === 'ag-addon-input') {
      var card = document.getElementById('ag-addon-card'); if (card) card.classList.toggle('is-on', t.checked);
      setDynamicHidden(t.checked); renderModal(); return;
    }
    if (t.matches && t.matches('.product-form__option-selector input, .product-form__option-selector select, input[name^="option"]')) { state.variantId = null; setTimeout(syncVariant, 50); }
  });
  function onVariant(e) {
    var f = e.target;
    if (f && f.tagName === 'FORM' && box() && !isOurForm(f)) return;
    var v = e.detail && e.detail.variant;
    state.variantId = v && v.id ? String(v.id) : null;
    setTimeout(syncVariant, 50);
  }
  document.addEventListener('variant:change', onVariant);
  document.addEventListener('variant:changed', onVariant);

  // Cambios dentro de Kaching (selector de reloj o cambio de barra)
  var kTimer = null;
  function kachingChanged() { clearTimeout(kTimer); kTimer = setTimeout(syncVariant, 80); }
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('kaching-bundle')) kachingChanged();
  });
  var kObs = null;
  function watchKaching() {
    var root = kachingRoot(); if (!root || root.__agObserved || !window.MutationObserver) return;
    root.__agObserved = true;
    kObs = new MutationObserver(function (list) {
      for (var n = 0; n < list.length; n++) {
        var r = list[n];
        if (r.type === 'attributes' && (r.attributeName === 'data-value' || r.attributeName === 'class')) { kachingChanged(); return; }
        if (r.type === 'childList' && r.target.closest && r.target.closest('.kaching-bundles__bar-variant-selects, .kaching-bundles__bars')) { kachingChanged(); return; }
      }
    });
    kObs.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-value', 'class'] });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-ag-info]')) { e.preventDefault(); openModal(); return; }
    var pill = t.closest('[data-ag-pill]');
    if (pill) { e.preventDefault(); state.choice = pill.dataset.agPill; refresh(); return; }
    if (t.closest('[data-ag-close]')) { closeModal(); return; }
    if (t.closest('[data-ag-prev]')) { state.slide = (state.slide + SLIDES.length - 1) % SLIDES.length; renderModal(); return; }
    if (t.closest('[data-ag-next]')) { state.slide = (state.slide + 1) % SLIDES.length; renderModal(); return; }
    if (t.closest('[data-ag-select]')) {
      var i = input(); if (!i) return;
      i.checked = !i.checked; i.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(closeModal, 250); return;
    }
    if (t === modal()) closeModal();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

  document.addEventListener('submit', async function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!isOurForm(form)) return;

    if (armed && !armed.used) armed.used = true;
    armed = null;
    fast = null;
    var i = input(), b = box();
    var bandOn = !!(i && i.checked && b && b.style.display !== 'none' && Number(i.dataset.bandVariant));
    var bandId = bandOn ? Number(i.dataset.bandVariant) : 0;
    mark('click'); T.band = bandOn;

    // Promos / Kaching: el Add to Cart sigue su camino normal; la banda (si esta activa) viaja
    // en el mismo pedido y el drawer abre con la respuesta, sin esperar otra lectura del carrito
    if (afterMode(form)) {
      armed = armFetch(bandId);
      return;
    }
    if (!bandOn) return;

    // PDP normal: reloj + banda en una sola llamada (igual que v5.2)
    e.preventDefault();
    e.stopImmediatePropagation();

    var fd = new FormData(form);
    var watchId = Number(fd.get('id'));
    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    if (!watchId) return;

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    var watchItem = { id: watchId, quantity: qty };
    var bandItem = { id: bandId, quantity: 1, properties: { '_added_with_watch': 'true' } };

    // Abre el drawer con el HTML que trae la respuesta (1 viaje en vez de 3)
    async function openAfter(r) {
      mark('add');
      var json = null; try { json = await r.json(); } catch (err) { json = null; }
      if (json && openFromAddResponse(json, false)) { broadcastCart(); return; }
      if (!(await openCartDrawer())) window.location.href = '/cart';
    }
    var res = await postItems([watchItem, bandItem], true);
    if (res.ok) {
      document.dispatchEvent(new CustomEvent('ag:band-added', { detail: { items: [watchItem, bandItem] } }));
      if (btn) btn.disabled = false;
      await openAfter(res);
      return;
    }
    var res2 = await postItems([watchItem], true);
    if (res2.ok) {
      document.dispatchEvent(new CustomEvent('ag:band-added', { detail: { items: [watchItem], bandFailed: true } }));
      if (btn) btn.disabled = false;
      notice('The metal band just sold out. Your watch was added to the cart.');
      await openAfter(res2);
      return;
    }
    if (btn) btn.disabled = false;
    notice('Something went wrong. Please try again.');
  }, true);

  // ---------- Arranque ----------
  function placeBelow() {
    var b = box(); if (!b || b.dataset.position !== 'below' || b.dataset.moved === '1') return;
    var f = ourForm();
    var buy = (f && f.closest('.product-form__buy-buttons')) || document.querySelector('.product-form__buy-buttons');
    if (!buy) return;
    buy.insertAdjacentElement('afterend', b); b.classList.add('ag-addon--below'); b.dataset.moved = '1';
  }
  function init() { placeBelow(); watchKaching(); state.lastVid = currentVariantId(); refresh(); var i = input(); if (i) setDynamicHidden(i.checked); }
  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () { MAP = null; init(); });
})();